import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLDivElement> {
  static values = { returnableItems: { type: Array, default: [] } };

  static targets = [
    "returnableItem",
    "toggleAllCheckbox",
    "submitButton",
    "returnableItemInput",
    "dateInput",
    "locationInput"
  ];

  selectedItems: Array<string> = [];

  declare returnableItemsValue: {
    id: string;
    product: { description: string };
    price: number;
    quantity: number;
    taxRate: string;
    unitOfMeasure: string;
    discount: number;
    subtotal: number;
    unretornedQuantity: number;
  }[];

  declare returnableItemTargets: HTMLDivElement[];

  declare toggleAllCheckboxTarget: HTMLInputElement;

  declare submitButtonTarget: HTMLButtonElement;

  declare returnableItemInputTargets: HTMLInputElement[];

  declare dateInputTarget: HTMLInputElement;

  declare locationInputTarget: HTMLInputElement;

  initialState: boolean;

  connect() {
    this.selectedItems = this.returnableItemInputTargets
      .filter((item) => item.checked)
      .map((input) => input.value);
    this.initialState = this.selectedItems.length === 0;

    this.updateToggleAllCheckbox();
  }

  selectItem(event: Event & { target: HTMLInputElement }) {
    if (event.target.checked) {
      this.selectedItems.push(event.target.value);
    } else {
      this.selectedItems = this.selectedItems.filter(
        (item) => item !== event.target.value
      );
    }
    this.updateToggleAllCheckbox();
    this.enableDisableSubmitButton();
  }

  toggleAll() {
    if (this.selectedItems.length === this.returnableItemsValue.length) {
      this.selectedItems = [];
    } else {
      this.selectedItems = this.returnableItemsValue.map((item) => item.id);
    }

    this.updateCheckboxes();
    this.enableDisableSubmitButton();
  }

  updateCheckboxes() {
    this.returnableItemInputTargets.forEach((checkbox) => {
      if (!checkbox) return;

      checkbox.checked = this.selectedItems.includes(checkbox.value);
    });
    this.updateToggleAllCheckbox();
  }

  updateToggleAllCheckbox() {
    this.toggleAllCheckboxTarget.checked = this.selectedItems.length > 0;
    if (
      this.selectedItems.length > 0 &&
      this.selectedItems.length < this.returnableItemsValue.length
    ) {
      this.toggleAllCheckboxTarget.setAttribute("partial", "true");
    } else {
      this.toggleAllCheckboxTarget.removeAttribute("partial");
    }
  }

  enableDisableSubmitButton() {
    this.submitButtonTarget.disabled =
      this.selectedItems.length === 0 ||
      this.dateInputTarget.value === "" ||
      this.locationInputTarget.value === "";
  }
}
